import { render, staticRenderFns } from "./Kecamatan.vue?vue&type=template&id=7b06b0aa&"
import script from "./Kecamatan.vue?vue&type=script&lang=js&"
export * from "./Kecamatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports